import React from "react";
import "../styles/GroupedUserList.css";
import NoResults from "./shared/NoResults";
import GroupedUserListGroup from "./GroupedUserListGroup"; // New component for rendering groups
import { useGroupedUserListStore } from "../store/useGroupedUserListStore";
import { useFetchUsers } from "../hooks/useFetchUsers"; // Custom hook for fetching users
import { groupByAlpha } from "../utils/groupByAlpha"; // Utility function for grouping users
import { SearchFilterLength } from "../constants";
import { Loader } from "../shared/ui";

const GroupedUserList = ({
    chatClient,
    currentUserId,
    searchValue,
    onUserSelect,
}) => {
    const { users, loading, setUsers, setLoading } = useGroupedUserListStore();

    // Use the custom hook to handle user fetching logic
    useFetchUsers(chatClient, currentUserId, searchValue, setUsers, setLoading);

    // Group users alphabetically
    const groups = groupByAlpha(users);

    return (
        <div className="grouped-user-list">
            {loading && <Loader loading={loading} className="flex-center" />}
            {Object.keys(groups).length === 0 &&
                searchValue?.length >= SearchFilterLength.GROUPED &&
                !loading && <NoResults />}
            {Object.keys(groups)
                .sort()
                .map((letter) => (
                    <GroupedUserListGroup
                        key={letter}
                        letter={letter}
                        users={groups[letter]}
                        onUserSelect={onUserSelect}
                    />
                ))}
        </div>
    );
};

export default GroupedUserList;